export function formatLongDisplayDate(dateString: string): string {
  const months = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const [year, month, day] = dateString.split('-');
  const monthName = months[parseInt(month) - 1];
  return `${monthName} ${parseInt(day)}, ${year}`;
}

export function getNextGameDateUTC(currentGameDateString: string) {
  const parts = currentGameDateString.split('-'); // Split the YYYY-MM-DD string
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JS Date
  const day = parseInt(parts[2], 10);

  const hour = 11; //Game updates at 11am UTC

  const date = new Date(Date.UTC(year, month, day, hour));
  return date;
}

export function getDatePartsFromMilliseconds(milliseconds: number) {
  return {
    days: Math.floor(milliseconds / (1000 * 60 * 60 * 24)),
    hours: Math.floor(
      (milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    ),
    minutes: Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: (milliseconds % (1000 * 60)) / 1000,
  };
}

export function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function daysBetweenDateStrings(
  dateString1: string,
  dateString2: string,
): number {
  const date1 = new Date(dateString1);
  const date2 = new Date(dateString2);

  const diffTime = Math.abs(date2.getTime() - date1.getTime());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}
